import upload from '@/services/upload'
import createFileName from './../dataMapping/createFileName'

const UploadSTL = async (stlFile, state) => {
  return new Promise((resolve, reject) => {
    const fileName = createFileName(state.product, 'stl')
    upload({
      file: stlFile,
      fileName: fileName,
      folderName: 'stl_files',
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default UploadSTL
